import { FC, useEffect } from "react";
import Typography from "@mui/material/Typography";
import { getSurveySection } from "app/features/surveySlice";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { FormControlModel } from "types";
import FormComponentFactory from "lib/factory/FormComponentFactory";
import { ElementType } from "lib/enums/enums";
import StepContent from "../StepContent";

type Props = {
  formik: any;
  sectionId: number;
};

const Step7: FC<Props> = ({ formik, sectionId }) => {
  const dispatch = useAppDispatch();
  const { surveySection } = useAppSelector((state) => state.survey) ?? [];
  const { questions = [] } = surveySection || {};

  useEffect(() => {
    dispatch(getSurveySection(sectionId));
  }, []);

  const clearFieldsConditioned = (value: string) => {
    if (value === "4992FDF8-0BD9-4D82-8DF4-ACDCC936A34E") {
      formik.setFieldValue("houseStatus", { ...formik.values.houseStatus, value: "" });
    }
  };

  const dataModel: Array<FormControlModel> = [
    {
      key: 0,
      formik,
      visible: true,
      name: "houseContition",
      label: "Su vivienda está:",
      questionData: questions[0],
      elementType: ElementType.Radio,
      onChangeCallback: clearFieldsConditioned,
    },
    {
      key: 1,
      formik,
      name: "houseStatus",
      visible: formik?.values?.houseContition?.value === "3BAE3882-1D00-44E9-894F-3FB64DEE73EC",
      label: "La construcción está",
      questionData: questions[0]?.subQuestions[0],
      elementType: ElementType.Select,
    },
    {
      key: 2,
      formik,
      name: "rooms",
      visible: true,
      type: "number",
      label: "¿En su vivienda cuántos espacios destinan como dormitorio?",
      questionData: questions[1],
      elementType: ElementType.Textfield,
    },
    {
      key: 3,
      formik,
      visible: true,
      name: "houseServices",
      label: "¿A cuáles de estos servicios públicos domiciliarios tiene acceso?",
      questionData: questions[2],
      elementType: ElementType.Checkbox,
      checkboxStyle: {
        minWidth: "200px",
        margin: "0 1.1rem",
        marginTop: "8px",
      },
    },
  ];

  return (
    <div>
      <Typography mb={2} variant='subtitle1' align='center'>
        Cuéntenos sobre su entorno: Estado de la vivienda actual
      </Typography>
      <StepContent>{dataModel.map(FormComponentFactory)}</StepContent>
    </div>
  );
};

export default Step7;
